import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

const NewItemDialogButton = ({ children, onClick }) => {
    return (
        <Button
            style={{ marginBottom: 12 }}
            variant="contained"
            color="primary"
            onClick={onClick}
        >
            {children}
        </Button>
    )
}

NewItemDialogButton.propTypes = {
    onClick: PropTypes.func.isRequired
}

export default NewItemDialogButton
